// src/components/TermsPage.jsx
import React, { useEffect } from "react";
import styled from "styled-components";
import { useLanguage } from "./LanguageContext";

const Page = styled.main`
  max-width: 980px;
  margin: 0 auto;
  padding: 28px 20px 60px;
  color: #0f0f0f;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  margin: 8px 0 16px;
  font-weight: 800;
`;

const Sub = styled.p`
  margin: 0 0 24px;
  color: #6b6b6b;
`;

const Section = styled.section`
  margin: 26px 0;
`;

const H2 = styled.h2`
  font-size: 1.15rem;
  margin: 0 0 10px;
  font-weight: 700;
`;

const P = styled.p`
  margin: 8px 0;
  line-height: 1.7;
  color: #222;
`;

const List = styled.ul`
  margin: 8px 0 8px 18px;
  line-height: 1.7;
  color: #222;
`;

const Badge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(0,0,0,0.08);
  background: rgba(17,24,39,0.06);
  font-size: 0.85rem;
  margin-left: 8px;
`;

const dict = {
  ka: {
    pageTitle: "წესები და პირობები | Shopaholics",
    h1: "წესები და პირობები",
    updated: "ბოლო განახლება: 2025",
    intro:
      "გთხოვთ, ყურადღებით წაიკითხოთ ეს წესები და პირობები Shopaholics.ge-ს გამოყენებამდე. საიტის გამოყენებით თქვენ ეთანხმებით ქვემოთ მოცემულ პირობებს.",
    s1: "1. ზოგადი პირობები",
    d1: [
      "Shopaholics.ge არის ონლაინ მაღაზია, რომელიც გთავაზობთ სუნამოებს და აქსესუარებს.",
      "ამ საიტის გამოყენებით თქვენ ადასტურებთ, რომ გაქვთ სრული უფლება დადოთ სამართლებრივი შეთანხმებები.",
    ],
    s2: "2. შეკვეთები და გადახდა",
    d2: [
      "ყველა შეკვეთა ექვემდებარება ხელმისაწვდომობასა და დადასტურებას.",
      "ფასები გამოხატულია ლარში (GEL).",
      "გადახდა ხდება უსაფრთხო პარტნიორი სისტემების (TBC Bank, Flitt) მეშვეობით.",
    ],
    s3: "3. მიწოდება და დაბრუნება",
    d3: [
      "მიწოდება ხდება მითითებულ მისამართზე რეგისტრაციის ან შეკვეთისას.",
      "გაყიდული პროდუქტი უკან არ დაბრუნდება.",
      "ქალაქის მასშტაბით მიწოდება 2-3 დღე."
    ],
    s4: "4. ინტელექტუალური საკუთრება",
    p4:
      "საიტზე არსებული ყველა ლოგო, ტექსტი, სურათი და დიზაინი ეკუთვნის Shopaholics-ს და დაცულია კანონით.",
    s5: "5. პასუხისმგებლობის შეზღუდვა",
    d5: [
      "Shopaholics არ არის პასუხისმგებელი ტექნიკური შეფერხებებით გამოწვეულ ზიანზე.",
      "ჩვენ არ ვიღებთ პასუხისმგებლობას მესამე მხარის ბმულებზე.",
    ],
    s6: "6. ცვლილებები",
    p6:
      "ჩვენ ვიტოვებთ უფლებას შევცვალოთ პირობები ნებისმიერ დროს. ცვლილებები გამოქვეყნდება ამ გვერდზე.",
    s7: "7. კონტაქტი",
    p7: "შეკითხვების შემთხვევაში მოგვწერეთ: support@shopaholics.ge | +995 558 641 621",
    langBadge: "KA",
    /* NEW: authenticity notice */
    note:
      "კომპანია აცხადებს, რომ მის მიერ შეთავაზებული პროდუქცია არის ავთენტური და ორიგინალი. პროდუქციის შეძენით მომხმარებელი ადასტურებს თანხმობას აღნიშნულ პირობებზე და უარს აცხადებს რაიმე პრეტენზიაზე პროდუქციის ავთენტურობასთან დაკავშირებით."
  },
  en: {
    pageTitle: "Terms & Conditions | Shopaholics",
    h1: "Terms & Conditions",
    updated: "Last Updated: 2025",
    intro:
      "Please read these Terms and Conditions carefully before using Shopaholics.ge. By using the website, you agree to the following terms.",
    s1: "1. General Terms",
    d1: [
      "Shopaholics.ge is an online store offering perfumes and accessories.",
      "By using this website, you confirm that you have the legal capacity to enter into agreements.",
    ],
    s2: "2. Orders and Payment",
    d2: [
      "All orders are subject to availability and confirmation.",
      "Prices are listed in Georgian Lari (GEL).",
      "Payments are processed securely via our partners (TBC Bank, Flitt).",
    ],
    s3: "3. Delivery and Returns",
    d3: [
      "Orders are delivered to the address provided during registration or checkout.",
      "Sold items cannot be returned.",
      "Citywide delivery 2-3 days.",
    ],
    s4: "4. Intellectual Property",
    p4:
      "All logos, text, images, and designs on this website are the property of Shopaholics and are legally protected.",
    s5: "5. Limitation of Liability",
    d5: [
      "Shopaholics is not liable for damages caused by technical interruptions.",
      "We are not responsible for third-party links.",
    ],
    s6: "6. Changes",
    p6:
      "We reserve the right to modify these terms at any time. Updates will be posted on this page.",
    s7: "7. Contact",
    p7: "For any questions, please contact: support@shopaholics.ge | +995 558 641 621",
    langBadge: "EN",
    /* NEW: authenticity notice */
    note:
      "The company declares that all products offered are authentic and original. By purchasing a product, the customer confirms acceptance of these terms and waives any claim regarding the product’s authenticity."
  },
};

const TermsPage = () => {
  const { language } = useLanguage();
  const i18n = dict[language] || dict.en;

  useEffect(() => {
    document.title = i18n.pageTitle;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [language, i18n.pageTitle]);

  return (
    <Page>
      <Title>
        {i18n.h1} <Badge>{i18n.langBadge}</Badge>
      </Title>
      <Sub>{i18n.updated}</Sub>
      <P>{i18n.intro}</P>

      <Section>
        <H2>{i18n.s1}</H2>
        <List>{i18n.d1.map((li, i) => <li key={i}>{li}</li>)}</List>
      </Section>

      <Section>
        <H2>{i18n.s2}</H2>
        <List>{i18n.d2.map((li, i) => <li key={i}>{li}</li>)}</List>
      </Section>

      <Section>
        <H2>{i18n.s3}</H2>
        <List>{i18n.d3.map((li, i) => <li key={i}>{li}</li>)}</List>
      </Section>

      <Section>
        <H2>{i18n.s4}</H2>
        <P>{i18n.p4}</P>
      </Section>

      <Section>
        <H2>{i18n.s5}</H2>
        <List>{i18n.d5.map((li, i) => <li key={i}>{li}</li>)}</List>
      </Section>

      <Section>
        <H2>{i18n.s6}</H2>
        <P>{i18n.p6}</P>
      </Section>

      <Section>
        <H2>{i18n.s7}</H2>
        <P>{i18n.p7}</P>
      </Section>

      {/* Authenticity notice shown subtly at the end */}
      <Section>
        <P style={{ color: "#6b6b6b", fontSize: "0.95rem" }}>{i18n.note}</P>
      </Section>
    </Page>
  );
};

export default TermsPage;
